import { Component, inject, signal, type WritableSignal } from '@angular/core';
import { CohortClientsDepositors } from "./cohort-clients-depositors/cohort-clients-depositors";
import { CohortDeposits } from "./cohort-deposits/cohort-deposits";
import { Navbar } from "../../../../shared/components/navbar/navbar";
import { CohortClientsBettors } from "./cohort-clients-bettors/cohort-clients-bettors";
import { CohortClientsRetention } from "./cohort-clients-retention/cohort-clients-retention";
import { CohortBets } from './cohort-bets/cohort-bets';
import { TabsModule } from 'primeng/tabs';
import { ReportsService } from '../../../../services/reports.service';
import { finalize } from 'rxjs';
import { CohortGgr } from "./cohort-ggr/cohort-ggr";

@Component({
  selector: 'app-cohort',
  imports: [
    Navbar,
    CohortClientsDepositors,
    CohortDeposits,
    CohortClientsBettors,
    CohortBets,
    CohortClientsRetention,
    TabsModule,
    CohortGgr
],
  templateUrl: './cohort.html',
  styleUrl: './cohort.css',
})
export class Cohort {
  private readonly _reportsService: ReportsService = inject(ReportsService);

  public financialBrandUtmSourceData: WritableSignal<any> = signal<any>(null);
  public financialBrandUtmSourceLoading: WritableSignal<boolean> = signal<boolean>(false);

  public ngOnInit(): void {
    this.getBrandUtmSource();
  }

  public getBrandUtmSource(): void {
    this.financialBrandUtmSourceLoading.set(true);

    this._reportsService.brandUtmSource()
      .pipe(finalize(() => this.financialBrandUtmSourceLoading.set(false)))
      .subscribe({
        next: (response) => {
          this.financialBrandUtmSourceData.set(response.data);
        }
      })
  }
}
